import WishlistCard from "../Components/wishlist/WishlistCard"

const WishlistPage = () => {
  return (
    <WishlistCard />
  )
}

export default WishlistPage